import React from "react";
import "./userlogin.scss";
import { Link } from "react-router-dom";
import { SmsValidator } from "../../../components";
import { StorageHelpers } from "../../../core/Helpers";
import { setUserToken } from "../../../redux/slices/authSlice";
import { setClinicName } from "../../../redux/slices/clinicSlice";
import InputMask from "react-input-mask";
import useLogin from "./useLogin";
import { Turnstile } from "@marsidev/react-turnstile";

const UserLogin = () => {
  const {
    form,
    formik,
    dispatch,
    navigate,
    setShowSmsValidationModal,
    showSmsValidationModal,
    isLoading,
    branches,
    branchesLoading,
  } = useLogin();
  return (
    <div className="main-login-area flex flex-col animate__animated animate__fadeIn">
      <div className="duration-300 w-fit md:w-[500px] text-xl font-semibold p-4  flex flex-col items-center">
        <Link to="/login">
          <div className="w-full justify-center flex flex-col gap-2 mb-4 items-center ">
            <img className="w-96" src="/assets/images/logo.png" alt="Logo" />
          </div>
        </Link>
        <span className="text-2xl md:text-4xl font-bold drop-shadow-md mb-1 duration-300">
          Hasta Sahibi Girişi
        </span>
        <div className="w-full justify-center flex flex-col mt-6">
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-6 flex flex-col font-normal">
              <input {...form.identityNr} />
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.identityNr && formik.errors.identityNr}
            </span>
            <div className="mt-6   flex flex-col font-normal">
              <InputMask {...form.gsm}></InputMask>
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.gsm && formik.errors.gsm}
            </span>
            <div className="mt-6 flex flex-col font-normal">
              <select {...form.idBranch}>
                {branchesLoading ? (
                  <option value="">Yükleniyor...</option>
                ) : (
                  branches?.map((branch) => (
                    <option key={branch.idBranch} value={branch.idBranch}>
                      {branch.branchName}
                    </option>
                  ))
                )}
              </select>
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.idBranch && formik.errors.idBranch}
            </span>
            <div className="flex justify-center mt-4">
              <Turnstile {...form.gRecaptcha} />
            </div>
            <div className="flex mt-4 items-center">
              <button {...form.loginButton}>
                {isLoading ? "Giriş Yapılıyor..." : "Giriş Yap"}
              </button>
            </div>
            <div className="text-xs text-center mt-4 flex flex-col">
              Giriş yaptıktan sonra sadece randevularınızı
              görüntüleyebilirsiniz.
              <span>
                Randevu almak için{" "}
                <a href="tel:+905334974838">0533 497 48 38</a> arayabilirsiniz.
              </span>
            </div>
          </form>
        </div>
      </div>

      <SmsValidator
        isOpen={showSmsValidationModal}
        onClose={() => setShowSmsValidationModal(false)}
        isUser={true}
        onVerify={(data) => {
          StorageHelpers.setUserAuthToken(data.token);
          dispatch(setUserToken(data.token));
          dispatch(setClinicName(data.name));
          navigate("/user-home");
        }}
        formikData={formik.values}
      />
    </div>
  );
};

export default UserLogin;
